module.exports = "pegasus/assets/themelp1/creative/101.png";